<template>
  <div class="head">
    <div class="info container">
      <h2>{{$t('platform.platform')}}</h2>
      <ul>
        <div>
          <p>{{$t('platform.info1')}}</p>
          <li>{{$t('platform.info11')}}</li>
          <li>{{$t('platform.info12')}}</li>
          <p>{{$t('platform.info2')}}</p>
          <li>{{$t('platform.info21')}}</li>
          <li>{{$t('platform.info22')}}</li>
        </div>
        <img class="pc" src="@/assets/image/platform/header.png" alt="data-platform-example">
      </ul>
      <img class="phone" src="@/assets/image/platform/header-s.png" alt="data-platform-example">
      <button><a href="/login-role">{{$t('platform.in')}}</a></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlatformHead'
}
</script>

<style lang="less" scoped>
.head {
  background-color: #F2F2F2;
  background-image: url('~@/assets/image/app/bg1.png');
  background-size: cover;
  overflow: hidden;
  padding: 4rem 0;
  min-height: calc(100vh - 9.375rem);
}
.info {
  position: relative;
}
h2 {
  width: 60%;
  font-size: 3rem;
  margin-bottom: 2rem;
}
ul {
  position: relative;
  font-size: 1.2rem;
  div {
    width: 35%;
    display: flex;
    flex-direction: column;
    line-height: 2rem;
    p {
      color: #4A4A4A;
      margin: 1rem 0 1rem;
    }
    li {
      color: #2482E0;
      font-weight: bold;
      line-height: 2.5rem;
      &::before {
        content: '';
        display: inline-block;
        height: 8px;
        width: 8px;
        border-radius: 1rem;
        background-color: #2482E0;
        margin-right: 1rem;
      }
    }
  }
}
img.pc {
  position: absolute;
  width: 65%;
  right: -50px;
  top: 15rem;
  transform: translateY(-50%);
}
button {
  position: absolute;
  top: 0;
  right: 0;
  outline: none;
  background: linear-gradient(180deg, #3780FF 0%, #1768F8 100%);
  padding: 0.5rem 1.2rem;
  box-shadow: 1px 4px 9px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  a {
    color: #fff;
    text-decoration: none;
  }
}
img.phone {
  display: none;
}
@media (max-width: 1300px) {
  .head {
    min-height: calc(100vh - 4.375rem);
  }
}
@media (max-width: 768px) {
  h2 {
    font-size: 26px;
    width: 100%;
    text-align: center;
    margin-bottom: 0;
  }
  ul {
    div {
      width: 100%;
      text-align: center;
      font-size: 12px;
      li {
        line-height: 2rem;
      }
    }
  }
  button {
    position: relative;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    a {
      font-size: 14px;
    }
    padding: 10px 15px;
  }
  img.pc {
    display: none;
  }
  img.phone {
    display: block;
    width: 100%;
  }
}
</style>
